module.exports = __webpack_public_path__ + "img/cube.973e2483.svg";